import React from 'react';
import styled from 'styled-components';

const GridContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0.75rem;
  padding-bottom: 5%;
`;

const GridCol = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: center;
`;

const GridItem = styled.img`
  display: block;
  width: ${({ $imgWidth = 'auto' }) => $imgWidth};
  height: auto;
  padding: 10px;
`;

const TwoColumns = ({ column, ...props }) => {
  return (
    <>
      <GridContainer>
        <GridCol>
          {column?.map((item, key) => (
            <GridItem
              {...props}
              key={key}
              src={item.src}
              alt={item.alt}
              $imgWidth={item.imgWidth}
            />
          ))}
        </GridCol>
      </GridContainer>
    </>
  );
};

export default TwoColumns;
